// import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import React from "react";
import {Typography} from "@mui/material";


export default function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <a href="https://directtrust.org/" >DirectTrust</a>
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
